import { Link, useParams } from "react-router-dom";
import SupportTicketThread from "components/SupportTickets/SupportTicketThread";
import { P } from "const/permissions";
import { usePermission } from "hooks/usePermissions";
import { SUPPORT_KEY, officeTicketApi } from "../supportTicketsApi";

/** A partner's ticket from the office side; replying and status changes need the send key. */
const SupportTicketDetailPage = () => {
  const { ticketId } = useParams();
  const canSend = usePermission(P.REFERRAL.MESSAGE_SEND);

  return (
    <div className="mt-4 px-4 pb-12 dashBody">
      <Link
        to="/admin/admin-referral/support"
        className="mb-3 inline-block text-xs text-app-text-muted no-underline"
      >
        ← All support tickets
      </Link>
      <SupportTicketThread
        ticketId={ticketId}
        api={officeTicketApi}
        keyBase={SUPPORT_KEY}
        viewerSide="OFFICE"
        canWrite={canSend}
      />
    </div>
  );
};

export default SupportTicketDetailPage;
